let GatewayAPI = {
    getURI: function () {
        let uri = "https://gateway.habtium.es/api/";
        if (
            window.location.hostname !== "habtium.es" &&
            window.location.hostname !== "www.habtium.es"
        ) {
            uri = "https://gateway.habtium.es/api/";
        }

        if (window.location.hostname === "localhost") {
            uri = "http://localhost:30000/api/";
        }

        return uri;
    },
    request: function (method, route, params, callback) {
        $.ajax({
            type: method,
            url: `${this.getURI()}${route}`,
            data: params,
        }).done(function (r) {
            callback(r);
        });
    },
    get: function (route, params, callback) {
        this.request("GET", route, params, callback);
    },
    put: function (route, params, callback) {
        this.request("PUT", route, params, callback);
    },
    post: function (route, params, callback) {
        this.request("POST", route, params, callback);
    },
    delete: function (route, params, callback) {
        this.request("DELETE", route, params, callback);
    },
};
